import { useState } from "react";

import aiPic from '../ai-bg.jpeg'
import devPic from '../dev-bg.jpeg'
import apiPic from '../api-bg.jpeg'
import { Link } from "react-router-dom";

export default function ProductType() {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        {
            id: 1,
            title: "AI Agents",
            image: aiPic,
            heading: "AI Agents",
            description: "Intelligent AI agents designed to automate risk assessment, document verification, fraud prevention, collections, and customer engagement helping lenders make faster, smarter, and more secure decisions at scale.",
        },
        {
            id: 2,
            title: "LNVS Fintech APIs",
            image: apiPic,
            heading: "LNVS Fintech APIs",
            description:
                "Power smarter lending decisions with ready-to-integrate APIs. Enable seamless data access, automated verification, and real-time risk assessment to accelerate loan processing and enhance customer experiences.",
        },
        {
            id: 3,
            title: "Deployable Solutions",
            image: devPic,
            heading: "Deployable Solutions",
            description:
                "Transform your lending operations with ready-to-use technology built for rapid deployment and growth. Reduce time-to-market, optimize performance, and deliver a frictionless customer experience from day one.",
        },

    ];
    return (
        <section className="h-[700px] bg-slate-100">
            <div className="text-center mb-10 sm:mb-14">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                    Products & Platforms
                </h2>
                <p className="text-sm sm:text-base md:text-lg text-slate-600 max-w-xl mx-auto">
                    Smart Solutions Built for Modern Lending
                </p>
            </div>
            <div className="flex h-full">

                {/* Left Vertical Tabs */}
                <div className="flex h-full">
                    {tabs.map((tab, index) => (
                        <div
                            key={tab.id}
                            onMouseEnter={() => setActiveTab(index)}
                            onClick={() => setActiveTab(index)}
                            className={`relative cursor-pointer overflow-hidden transition-all duration-500
              ${activeTab === index
                                    ? "w-56"
                                    : "w-24"
                                }`}
                        >
                            <img
                                src={tab.image}
                                alt={tab.title}
                                className="absolute inset-0 w-full h-full object-cover"
                            />

                            <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 to-pink-500/50" />

                            <div className="absolute inset-0 flex items-center justify-center">
                                <h3 className="text-white font-bold text-2xl rotate-[-90deg] whitespace-nowrap">
                                    {tab.title}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Right Content */}
                <div
                    className="flex-1 bg-cover bg-center relative transition-all duration-700"
                    style={{
                        backgroundImage: `url(${tabs[activeTab].image})`,
                    }}
                >
                    <div className="absolute inset-0 bg-[#172f47]/50 backdrop-blur-sm" />

                    <div className="relative z-10 h-full flex items-center">
                        <div className="max-w-4xl px-16 text-white">
                            <h2 className="text-4xl font-bold  mb-8 ">
                                {tabs[activeTab].heading}
                            </h2>

                            <p className="text-lg leading-relaxed">
                                {tabs[activeTab].description}
                            </p>

                            <Link to={'/product'}>
                                <button className="mt-10 text-xl font-semibold hover:bg-cyan-400 border p-4 rounded-lg">
                                    Learn More →
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
